/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBackOfficeReasonCode.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/back-office-reason-code";

export class AutogenModelBackOfficeReasonCode<RowType extends ModelRow> extends Endpoint<RowType, RowBackOfficeReasonCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBackOfficeReasonCode extends ModelRow<RowBackOfficeReasonCodeFields> {
	constructor(values?: Partial<RowBackOfficeReasonCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBackOfficeReasonCodeFields {
	code_type: string;
	company_id: string;
	descr: string;
	id: string;
	is_active: string;
}

